// Mercapoli - Loading Screen Component
// Full-screen loading state for app initialization
import React from 'react';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';

const LoadingScreen = ({ message = "Cargando..." }) => {
  const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        {/* Logo with pulse animation */}
        <motion.div
          animate={{ 
            scale: [1, 1.05, 1],
            opacity: [0.8, 1, 0.8]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="mb-6"
        >
          <img 
            src={LOGO_URL} 
            alt="Mercapoli" 
            className="h-20 w-20 mx-auto"
          />
        </motion.div>

        {/* Spinner */}
        <div className="flex items-center justify-center gap-2 text-muted-foreground">
          <Loader2 className="h-5 w-5 animate-spin" />
          <span className="text-sm">{message}</span>
        </div>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
